import { Grid, Typography } from '@mui/material';
import React, { ChangeEvent } from 'react';
import { SubscriptionBillingInput } from '../../../shared/types/generated';
import { InputDefaultUserBilling } from '../../../shared/components/InputDefaultUserBilling';

type ShippingInfoProps = {
  subscriptionBilling: SubscriptionBillingInput;
  onChange: (name: string, value: string) => void;
};
export const ShippingInfoNewMinimal: React.FC<ShippingInfoProps> = ({
  subscriptionBilling,
  onChange,
}) => {
  const onChangeHandler = (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ): void => {
    onChange(
      event.target.name as keyof SubscriptionBillingInput,
      event.target.value as string,
    );
  };

  return (
    <>
      <Typography
        pb={1}
        pt={2}
        fontFamily={'oswald'}
        textTransform={'uppercase'}
        fontSize={{ xs: '18px', md: '20px' }}
        lineHeight={{ xs: '20px', md: '22px' }}
        textAlign={'center'}
      >
        Ingresa tu información:
      </Typography>
      <Typography
        color={'#FF3C41'}
        fontFamily={'manop'}
        marginBottom={'10px'}
        fontWeight={400}
      >
        {' '}
        * Campos obligatorios{' '}
      </Typography>
      <Grid container spacing={'10px'}>
        <Grid item xs={12}>
          <InputDefaultUserBilling
            label="Estado*"
            name="state"
            value={subscriptionBilling.state as string}
            onChange={(event) => onChangeHandler(event)}
          />
        </Grid>
        <Grid item xs={12}>
          <InputDefaultUserBilling
            label="Número telefónico de contacto*"
            name="phone"
            value={subscriptionBilling.phone as string}
            onChange={(event) => onChangeHandler(event)}
          />
        </Grid>
      </Grid>
    </>
  );
};
